import React from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import KwPanel from '../../common/KwPanel';
import { toast } from 'react-toastify';
import Button from '../../common/Button';
import ConfirmationHeader from '../../common/ConfirmationHeader';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../hooks';
import { deleteCompanyAction } from '../../../reducers/companyReducer';

export interface DeleteProps {
  done: () => void;
  id: string | undefined;
  cancel: () => void;
}

function Delete({ done, id, cancel }: DeleteProps) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleDelete = () => {
    if (!id) return;
    dispatch(deleteCompanyAction(id))
      .then(() => {
        toast.success(t('Company successfully deleted'));
        done();
      })
      .catch(() => {
        toast.error(t('Failed to delete company'));
      });
  };

  return (
    <>
      <SlideoutLayout
        title={t('Delete confirmation')}
        cancel={cancel}
      >
        <KwPanel>
          <ConfirmationHeader text={t('Are you sure?')} />
          <p>
            {t('This will also archive any users associated with this company')}
          </p>
          <Button
            className="btn btn-danger me-2"
            onClick={handleDelete}
            text={t('Yes, delete the company')}
          />
          <Button
            className="btn btn-default"
            onClick={cancel}
            autoFocus={true}
            text={t('No, cancel')}
          />
        </KwPanel>
      </SlideoutLayout>
    </>
  );
}

export default Delete;
